import React, { useState, useRef } from 'react';
import { Menu, Button, Stack, Box } from '@mui/material';
import { DateRangePicker } from 'react-date-range';
import dayjs from 'dayjs';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import StatusIndicator from './StatusIndicator';

export type DateRangeItem = {
  startDate: Date;
  endDate: Date;
  key: string;
}

const DatePicker = (props: { color?: string, label: string; dateRange: DateRangeItem, onChange: (values: DateRangeItem) => void }) => {

  const [showsPicker, showPicker] = useState(false);
  const pickerRef = useRef();

  return <>
    <Button variant="text" 
            size="small"
            color="secondary"
            onClick={() => showPicker(true)} 
            ref={pickerRef}>
      <Stack direction="row" alignItems="stretch" gap={1}>
        <Box sx={{width: 4, bgcolor: `var(--color-${props.color ?? "purple"})`, my: 0.45, borderRadius: 'var(--border-radius-item)'}} />
        <Stack gap={0} alignItems="flex-start" lineHeight={1.4}>
          <Stack direction="row" alignItems="center">
            <small className="text-secondary text-light">{props.label}</small>
            <ArrowDropDownIcon fontSize='small' />
          </Stack>
          <span>{`${dayjs(props.dateRange.startDate).format('L')} to ${dayjs(props.dateRange.endDate).format('L')}`}</span>
        </Stack>
      </Stack>
    </Button>

    <Menu
      anchorEl={pickerRef.current}
      open={showsPicker}
      onClose={() => showPicker(false)}
      sx={{['.MuiList-root']: { p: 0 }}}
    >
      <DateRangePicker
          onChange={props.onChange}
          ranges={[{...props.dateRange, startDate: dayjs(props.dateRange.startDate), endDate: dayjs(props.dateRange.endDate) }]}
          maxDate={new Date()}
          inputRanges={[]}
          rangeColors={[`var(--color-${props.color ?? 'purple'})`]}
        />
    </Menu>
  </>
}

export default DatePicker;